import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Storage} from "@ionic/storage";
import {ToastController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class VersionCheckService {

  private intervalHolder: any;

  constructor(
    private http: HttpClient,
    public storage: Storage,
    private toastCtrl: ToastController,
    public translate: TranslateService,
  ) {
  }

  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 30 minutes
   */
  public initVersionCheck(url, frequency = 1000 * 60 * 30) {
    this.intervalHolder = setInterval(() => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    this.http
      .get(url + "?t=" + new Date().getTime())
      .first()
      .subscribe(
        async (response: any) => {
          const hash = response.hash;
          const hashChanged = await this.hasHashChanged(hash);

          // If new version, do something
          if (hashChanged) {
            // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
            // location.reload(true);
            const toast = this.toastCtrl.create({
              message: this.translate.instant('The website has been updated, please press Refresh to Hard Reload'),
              position: 'bottom',
              showCloseButton: true,
              closeButtonText: 'Refresh',
            });

            toast.onDidDismiss(() => {
              location.reload();
            });

            await toast.present();
          }

          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          await this.storage.set('hash', hash)
        },
        err => {
          clearInterval(this.intervalHolder);
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param newHash
   * @returns {boolean}
   */
  private async hasHashChanged(newHash) {

    const currentHash = await this.storage.get('hash')
    if (!currentHash) {
      return false;
    }

    return currentHash !== newHash;
  }
}



// WEBPACK FOOTER //
// ./src/providers/version-check/version-check.service.ts